import { RouteMetadata } from './types';

export const adminPlaybooksMetadata: RouteMetadata[] = [
    {
        pattern: '/admin/playbooks/:playbookId/versions/:versionId/builder/steps/:stepId',
        section: 'admin',
        view: 'playbook-step-settings',
        descriptionTemplate:
            'User is editing step {stepId} settings for playbook {playbookId}, version {versionId}',
        capabilities: [
            'Edit step name, instructions, and schema-driven parameters',
            'Save step changes to the draft playbook version',
            'Return to the playbook builder canvas',
        ],
        hints: [
            'Opened from a selected step on the playbook builder canvas',
            'Route is /admin/playbooks/:playbookId/versions/:versionId/builder/steps/:stepId',
        ],
    },
    {
        pattern: '/admin/playbooks/:playbookId/versions/:versionId/document',
        section: 'admin',
        view: 'playbook-document',
        descriptionTemplate:
            'User is reading playbook {playbookId} as a document for version {versionId}',
        capabilities: [
            'Read the playbook top-to-bottom as an SOP document',
            'Switch back to the canvas builder view',
            'Publish or create a draft version from the toolbar',
            'Return to the playbooks library',
        ],
        hints: [
            'Canonical document URL includes playbookId and versionId',
            'Opened via the Canvas / Document tabs on the playbook builder top bar',
        ],
    },
    {
        pattern: '/admin/playbooks/:playbookId/versions/:versionId/slides',
        section: 'admin',
        view: 'playbook-slides',
        descriptionTemplate:
            'User is presenting playbook {playbookId} as slides for version {versionId}',
        capabilities: [
            'Walk the playbook one step per slide with keyboard or on-screen controls',
            'Choose a branch on decision slides to present a single path',
            'Jump back to a decision or switch branch from the path breadcrumb',
            'Switch back to the canvas or document view',
        ],
        hints: [
            'Canonical slides URL includes playbookId and versionId',
            'Opened via the Canvas / Document / Slides tabs on the playbook builder top bar',
        ],
    },
    {
        pattern: '/admin/playbooks/:playbookId/versions/:versionId/builder',
        section: 'admin',
        view: 'playbook-builder',
        descriptionTemplate:
            'User is editing playbook {playbookId} in the admin builder for version {versionId}',
        capabilities: [
            'Compose playbook steps on a React Flow canvas',
            'Add steps from the step definitions palette',
            'Open step settings, publish, or create a draft version',
            'Switch to the read-only document view',
            'Return to the playbooks library',
        ],
        hints: [
            'Canonical builder URL includes playbookId and versionId',
            'Playbooks is under Operations in the admin sidebar',
        ],
    },
    {
        pattern: '/admin/playbooks/:playbookId/builder',
        section: 'admin',
        view: 'playbook-builder',
        descriptionTemplate:
            'User is opening the admin playbook builder for playbook {playbookId} (version redirect)',
        capabilities: [
            'Resolve to the latest draft or published version builder',
            'Return to the playbooks library',
        ],
        hints: [
            'Bare /builder redirects to /versions/:versionId/builder',
            'Opened from a playbook card or after creating a playbook',
        ],
    },
    {
        pattern: '/admin/playbooks',
        section: 'admin',
        view: 'playbooks',
        descriptionTemplate: 'User is viewing the admin playbooks process library',
        capabilities: [
            'Browse internal playbooks by Grow, Fulfillment, and Innovation',
            'Filter playbooks by owner or status',
            'Create, edit, or remove playbooks',
            'Open a playbook in the builder',
        ],
        hints: [
            'Playbooks is under Operations in the admin sidebar',
            'Library data comes from GET /admin/playbooks',
        ],
    },
];
